/**
 * INVICT Security Solutions — official brand mark.
 * Renders the real isotype + wordmark extracted from the official Brand Book PDF.
 *
 * Props:
 *  - size: "xs" | "sm" | "md" | "lg" | "xl"  (controls overall height)
 *  - variant:
 *      "auto"        -> resolved from legacy `invert` flag (default)
 *      "light-bg"    -> red isotype + black wordmark   (use on bone / white bg)
 *      "dark-bg"     -> red isotype + bone-white wordmark (use on black bg)
 *      "mono-white"  -> full logo in single bone white
 *      "mono-black"  -> full logo in single pure black
 *  - invert: legacy. when `true`, logo is rendered for LIGHT background.
 *            when `false` (default), logo is rendered for DARK background.
 *  - iconOnly: render only the isotype (no wordmark).
 */
const HEIGHTS = { xs: 18, sm: 26, md: 36, lg: 52, xl: 76 };

const LOGO = {
  "light-bg": "/brand/invict-logo.png",
  "dark-bg": "/brand/invict-logo-dark.png", // Fix AP (2026-09-25): centro del isotipo en blanco sobre negro
  "mono-white": "/brand/invict-logo-mono-white.png",
  "mono-black": "/brand/invict-logo-mono-black.png",
};
const ISO = {
  "light-bg": "/brand/invict-isotype.png",
  "dark-bg": "/brand/invict-isotype-dark.png", // Fix AP (2026-09-25): centro del isotipo en blanco sobre negro
  "mono-white": "/brand/invict-isotype-white.png",
  "mono-black": "/brand/invict-isotype.png",
};

function resolveVariant(variant, invert) {
  if (variant && variant !== "auto") return variant;
  return invert ? "light-bg" : "dark-bg";
}

export function Brand({ size = "md", variant = "auto", invert = false, iconOnly = false }) {
  const v = resolveVariant(variant, invert);
  const h = HEIGHTS[size] || HEIGHTS.md;
  const src = iconOnly ? (ISO[v] || ISO["light-bg"]) : (LOGO[v] || LOGO["light-bg"]);

  return (
    <span
      data-testid="brand-mark"
      style={{
        display: "inline-flex",
        alignItems: "center",
        alignSelf: "flex-start",
        height: h,
        lineHeight: 0,
        flexShrink: 0,
      }}
    >
      <img
        src={src}
        alt="INVICT Security Solutions"
        style={{
          height: "100%",
          width: "auto",
          display: "block",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </span>
  );
}

export default Brand;
